import axios from 'axios';

import URLS from '../../util/urls.js';

import funcoes from '../../util/funcoes.js'

const state = {
  listaLogs: [],
  labelQuantidade: '',
  logPesquisa: {
    dataInicial: undefined,
    dataFinal: undefined,
    texto: undefined,
    cliente: undefined,
    usuario: undefined,
    imovel: undefined,
    aluguel: undefined,
    pagina: 0
  },

  listaClientes: [],
  labelQuantidadeClientes: '',
  clientePesquisa: {
    idNaImobiliaria: undefined,
    nome: undefined,
    pagina: 0
  },

  listaUsuarios: [],
  labelQuantidadeUsuarios: '',
  usuarioPesquisa: {
    nome: undefined,
    pagina: 0
  },
  
  listaAlugueis: [],
  labelQuantidadeAlugueis: '',
  aluguelPesquisa: {
    idNaImobiliaria: undefined,
    locatario: { nome: undefined },
    pagina: 0
  },

  listaImoveis: []
};
const mutations = {
  atualizarListaLogs(state, payload) {
    if(state.logPesquisa.pagina === 0) {
      state.listaLogs = payload.lista;
    } else {
      state.listaLogs.push(...payload.lista);
    }
    state.labelQuantidade = `${payload.quantidade} ${payload.quantidade === 1 ? "Log encontrado" : "Logs encontrados"}`;
  },
  limparLogsListados(state) {
    state.listaLogs = [];
  },
  limparLogPesquisa(state) {
    state.logPesquisa = {
      dataInicial: funcoes.primeiroDiaMes(),
      dataFinal: funcoes.ultimoDiaMes(),
      texto: undefined,
      cliente: undefined,
      usuario: undefined,
      imovel: undefined,
      aluguel: undefined,
      pagina: 0
    }
  },
  limparCamposPesquisaData(state) {
    state.logPesquisa.dataInicial = undefined;
    state.logPesquisa.dataFinal = undefined;
  },

  atualizarListaClientes(state, payload) {
    if(state.clientePesquisa.pagina === 0) {
      state.listaClientes = payload.lista;
    } else {
      state.listaClientes.push(...payload.lista);
    }
    state.labelQuantidadeClientes = `${payload.quantidade} ${payload.quantidade === 1 ? "Cliente encontrado" : "Clientes encontrados"}`;
  },
  limparClientesListados(state) {
    state.listaClientes = [];
  },
  limparClientePesquisa(state) {
    state.clientePesquisa = {
      idNaImobiliaria: undefined,
      nome: undefined,
      pagina: 0
    }
  },
  limparCampoCliente(state) {
    state.logPesquisa.cliente = undefined;
  },

  atualizarListaUsuarios(state, payload) {
    if(state.usuarioPesquisa.pagina === 0) {
      state.listaUsuarios = payload.lista;
    } else {
      state.listaUsuarios.push(...payload.lista);
    }
    state.labelQuantidadeUsuarios = `${payload.quantidade} ${payload.quantidade === 1 ? "Usuário encontrado" : "Usuários encontrados"}`;
  },
  limparUsuariosListados(state) {
    state.listaUsuarios = [];
  },
  limparUsuarioPesquisa(state) {
    state.usuarioPesquisa = {
      nome: undefined,
      pagina: 0
    }
  },
  limparCampoUsuario(state) {
    state.logPesquisa.usuario = undefined;
  },

  limparCampoImovel(state) {
    state.logPesquisa.imovel = undefined;
  },

  atualizarListaAlugueis(state, payload) {
    if(state.aluguelPesquisa.pagina === 0) {
      state.listaAlugueis = payload.lista;
    } else {
      state.listaAlugueis.push(...payload.lista);
    }
    state.labelQuantidadeAlugueis = `${payload.quantidade} ${payload.quantidade === 1 ? "Aluguel encontrado" : "Aluguéis encontrados"}`;
  },
  limparAlugueisListados(state) {
    state.listaAlugueis = [];
  },
  limparAluguelPesquisa(state) {
    state.aluguelPesquisa = {
      idNaImobiliaria: undefined,
      locatario: { nome: undefined },
      pagina: 0
    }
  },
  limparCampoAluguel(state) {
    state.logPesquisa.aluguel = undefined;
  },
  atualizarListaImoveis(state, payload) {
    state.listaImoveis = payload
  }
};
const actions = {
  listarLogs(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaLogs', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarLogs', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparLogsListados(context) {
    context.commit('limparLogsListados');
  },
  limparLogPesquisa(context) {
    context.commit('limparLogPesquisa');
  },
  limparCamposPesquisaData(context) {
    context.commit('limparCamposPesquisaData');
  },

  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaClientes', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarClientes', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  gerarRelatorioLogs(context, payload) {

    return axios.post(URLS.RELATORIOS_GERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            window.open(response.data.mensagem, "_blank")
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gerarRelatorioLogs', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  
  limparClientesListados(context) {
    context.commit('limparClientesListados');
  },
  limparClientePesquisa(context) {
    context.commit('limparClientePesquisa');
  },
  limparCampoCliente(context) {
    context.commit('limparCampoCliente');
  },

  listarUsuarios(context, payload) {
    return axios.post(URLS.USUARIOS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaUsuarios', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarUsuarios', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparUsuariosListados(context) {
    context.commit('limparUsuariosListados');
  },
  limparUsuarioPesquisa(context) {
    context.commit('limparUsuarioPesquisa');
  },
  limparCampoUsuario(context) {
    context.commit('limparCampoUsuario');
  },
  
  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaImoveis', response.data.lista)
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarImoveis', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparCampoImovel(context) {
    context.commit('limparCampoImovel');
  },

  listarAlugueis(context, payload) {
    return axios.post(URLS.ALUGUEIS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaAlugueis', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarAlugueis', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparAlugueisListados(context) {
    context.commit('limparAlugueisListados');
  },
  limparAluguelPesquisa(context) {
    context.commit('limparAluguelPesquisa');
  },
  limparCampoAluguel(context) {
    context.commit('limparCampoAluguel');
  }
};

export default {
  state,
  mutations,
  actions
};